import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const useMapVisibility = () => {
  const [mapEnabled, setMapEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMapVisibility = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${API_BASE_URL}/features/map-visibility`);
      setMapEnabled(response.data.enabled);
    } catch (err) {
      console.error('Error fetching map visibility:', err);
      setError(err);
      // Default to false if there's an error
      setMapEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMapVisibility();
  }, []);

  return {
    mapEnabled,
    loading,
    error,
    refetch: fetchMapVisibility
  };
};
